import React from 'react';

export const Hero: React.FC = () => {
  return (
    <section id="top" className="hero">
      <div className="container hero-grid">
        <div>
          <span className="section-eyebrow">Push-to-talk for the road</span>
          <h1 className="hero-title">
            The CB radio,
            <br />
            <span className="accent">reinvented</span> for modern
            <br />
            truck drivers.
          </h1>
          <p className="hero-lede">
            RoadStatic is a push-to-talk voice app built for life behind the
            wheel. Talk to friends, private convoy groups, or every driver
            within five miles — straight from a phone or in-cab tablet.
          </p>
          <div className="hero-actions">
            <a className="btn btn-primary" href="#features">
              See how it works
            </a>
            <a className="btn btn-ghost" href="#use-cases">
              Who it's for
            </a>
          </div>
        </div>

        <div className="phone" aria-hidden="true">
          <div className="phone-screen">
            <div className="phone-bar">
              <span className="phone-bar-dot" />
              RoadStatic
            </div>
            <div className="phone-tabs">
              <div className="phone-tab">5-Mile Radius</div>
              <div className="phone-tab active">Friends &amp; Groups</div>
            </div>
            <div className="phone-body">
              <div className="phone-row">
                <span>
                  <span className="dot" />
                  Big Rig Mike
                </span>
                <span style={{ color: '#ffd23f' }}>Online</span>
              </div>
              <div className="phone-row">
                <span>
                  <span className="dot" />
                  Sarah_Trucker
                </span>
                <span style={{ color: '#ffd23f' }}>Online</span>
              </div>
              <div className="phone-row">
                <span>
                  <span className="dot off" />
                  HighwayHank
                </span>
                <span style={{ color: '#888' }}>Offline</span>
              </div>
              <div className="phone-row">
                <span style={{ color: '#ff6b35', fontWeight: 600 }}>
                  ▶ Convoy: I-80 East
                </span>
                <span style={{ color: '#b8b8b8' }}>4</span>
              </div>
            </div>
            <div className="phone-ptt">
              <div className="phone-ptt-button">PTT</div>
              <div className="phone-ptt-label">Press to transmit</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
